"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionRegistry = exports.SchemaRegistry = void 0;
/**
 * Registry for schemas
 */
class SchemaRegistry {
    constructor() {
        this.registry = {};
    }
    register(id, node) {
        this.registry[id] = node;
    }
    get(id) {
        const node = this.registry[id];
        if (node === undefined) {
            console.error(`Tried to access schema "${id}", but that doesn't exist.`);
        }
        return node;
    }
}
exports.SchemaRegistry = SchemaRegistry;
/**
 * Registry for collections
 */
class CollectionRegistry {
    constructor() {
        this.registry = {};
    }
    register(id, list) {
        this.registry[id] = list;
    }
    get(id) {
        const list = this.registry[id];
        if (list === undefined) {
            console.warn(`Tried to access collection "${id}", but that doesn't exist.`);
        }
        return list !== null && list !== void 0 ? list : [];
    }
}
exports.CollectionRegistry = CollectionRegistry;
